import React from 'react';
import LumenFindLogo from '../images/veomate-arch.png';

const Home = () => {
  return (
    <div className="flex flex-col items-center justify-center h-full">
    </div>
  );
};

export default Home;
